var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "mainContent" }, [
        _c("div", { staticClass: "mainContent__paragraphs" }, [
          _c("p", [_vm._v(_vm._s(_vm.fieldGroup.description))])
        ]),
        _vm._v(" "),
        _vm.hasGeneral
          ? _c(
              "div",
              [
                _vm.hasBoth
                  ? _c("h2", { staticClass: "mainContent__title" }, [
                      _vm._v("Geral")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(_vm.specificComponent, {
                  ref: "generalComponent",
                  tag: "component",
                  attrs: { fields: _vm.fieldGroup.general },
                  model: {
                    value: _vm.app_config_part.general,
                    callback: function($$v) {
                      _vm.$set(_vm.app_config_part, "general", $$v)
                    },
                    expression: "app_config_part.general"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.loaded && _vm.hasPerWarehouse
          ? _c("div", [
              _vm.hasBoth
                ? _c("h2", { staticClass: "mainContent__title" }, [
                    _vm._v("Por CD")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "per_warehouse" },
                [
                  _c("sc-warehouses-list", {
                    ref: "warehouseListComponent",
                    attrs: {
                      editable: false,
                      configurable: true,
                      fields: _vm.fieldGroup.per_warehouse,
                      specificComponent: _vm.specificComponent,
                      currentWarehouseValue: _vm.currentWarehouseValue
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("help-button")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bdda8a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bdda8a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/base/ScFieldGroup.vue
// module id = null
// module chunks = 